<template>
  <v-row :class="rowClass">
    <v-col cols="auto">
      <a
        :href="linkAppStore"
        rel="noopener noreferrer"
        target="_blank"
        @click.stop="
          !gtm ||
          gtmPush({
            event: gtm.event,
            link_text: 'AppStore',
            link_location: gtm.link_location
          })
        "
      >
        <img
          src="@/assets/img/appstore.png"
          srcset="@/assets/img/appstore@2x.png 2x"
          :alt="$t('downloadAppStore')"
        />
      </a>
    </v-col>
    <v-col cols="auto" :class="{ 'order-first': googleFirst }">
      <a
        :href="linkGooglePlay"
        rel="noopener noreferrer"
        target="_blank"
        @click.stop="
          !gtm ||
          gtmPush({
            event: gtm.event,
            link_text: 'GooglePlay',
            link_location: gtm.link_location
          })
        "
      >
        <img
          src="@/assets/img/googleplay.png"
          srcset="@/assets/img/googleplay@2x.png 2x"
          :alt="$t('downloadGooglePlay')"
        />
      </a>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AppButtons',
  props: {
    rowClass: {
      type: String,
      default: ''
    },
    linkAppStore: {
      type: String,
      required: true
    },
    linkGooglePlay: {
      type: String,
      required: true
    },
    googleFirst: {
      type: Boolean,
      default: false
    },
    gtm: {
      type: Object,
      default: () => ({
        event: 'button_click',
        /* eslint-disable-next-line camelcase */
        link_location: 'app-buttons'
      })
    }
  }
};
</script>
